import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8000";
// export const baseURL = "https://motorcare-backend.metropolitano.tech";

export const baseURL = (() => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return "https://gwm-backend.metropolitano.tech"; // Local development API
  } else if (hostname === "gwm.metropolitano.tech") {
    return "https://gwm-backend.metropolitano.tech"; //  API
  } else if (hostname === "ronil.metropolitano.tech") {
    return "https://ronil-backend.metropolitano.tech"; // Production API
  } else if (hostname === "caetano.metropolitano.tech") {
    return "https://caetano-backend.metropolitano.tech"; // Production API
  } else if (hostname === "mozam.metropolitano.tech") {
    return "https://mozam-backend.metropolitano.tech"; // Production API
  }  else if (hostname === "suzuki.metropolitano.tech") {
    return "https://suzuki-backend.metropolitano.tech"; // Production API
  }  else if (hostname === "mhl.metropolitano.tech") {
    return "https://mhl-backend.metropolitano.tech"; // Production API
  } else {
    throw new Error("Unknown domain! Cannot set API baseURL.");
  }
})();

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
